import React, { useRef} from "react";
import Slider from "react-slick";

export default function HomeTestimonial({extraClass}) {
    const sliderRef = useRef(null);

    const settings = {
        dots: true,
        arrows: false,
        infinite: true,
        speed: 1500,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        pauseOnHover: false,
        cssEase: "ease",
    };

  return (
    <>
    <div className={`home-testimonial ${extraClass}`}>
        <div className="container">
            <div className="row">  

                <div className="col-lg-3 col-sm-3">
                    <img src="/image/big-quote.webp" loading="lazy" className="img-responsive" alt="quote"/>
                </div>

                <div className="col-lg-9 col-sm-9">
                    <Slider {...settings} ref={sliderRef} className="testim-slider">
                        <div>
                            <div className="hometesti-para">
                                <p>Sunil ji & team did fabulous job. Quality & designs are top notch. After sales service is very prompt. Highly recommended. Beds are trendy & wardrobe looks so classy. Highly satisfied with their team.</p>
                                <div>
                                    <img src="/image/testiclient-1.webp" loading="lazy" alt="client"/>
                                    <span>Saurabh Pasricha</span>
                                </div>
                            </div>
                        </div>

                        <div>
                            <div className="hometesti-para">
                                <p>Saysha & team did a fabulous job. Amazing beds with a superb storage. Love the colours. Highly trained staff. Crockery unit came up so beautiful. 10/10</p>
                                <div>
                                    <img src="/image/testiclient-2.webp" loading="lazy" alt="client"/>
                                    <span>Nidhi Kalra</span>
                                </div>
                            </div>
                        </div>

                        <div>
                            <div className="hometesti-para">
                                <p>I just fell in love with my bedroom even the lobby part is more much prettier than my bedroom. Love the finishing cleaning love the stuff they used. Everything is just perfect. Thanks a lot SAYSHA</p>
                                <div>
                                    <img src="/image/testiclient-3.webp" loading="lazy" alt="client"/>
                                    <span>Vivek Singh</span>
                                </div>
                            </div>
                        </div>

                        <div>
                            <div className="hometesti-para">
                                <p>Interior designer for modular kitchen, wardrobe, furniture etc. Mainly known for their quality product n fine finishing.</p>
                                <div>
                                    <img src="/image/testiclient-4.webp" loading="lazy" alt="client"/>
                                    <span>Subhash Saini</span>
                                </div>
                            </div>
                        </div>
                    </Slider>
                </div>

            </div>
        </div>
    </div> 
    </>
  )
}
